import { ApolloClient } from '@apollo/client';

import { cache } from './cache';

export const CONTENTFUL_API = 'https://graphql.contentful.com/content/v1/spaces';

export const apolloClient = new ApolloClient({
  uri: `${CONTENTFUL_API}/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}?access_token=${process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN}`,
  cache
});
